module.exports = __webpack_public_path__ + "static/polypane-ryan-bf5b2edb3cebd65d3e9ff6bcdf9ff823.jpg";